import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import { useAuth } from 'src/features/authorization';
import useTimeEntries from 'src/hooks/use-time-entries';
import InkindTable from '../components/InkindTable';
import NoAccess from 'src/components/NoAccess/NoAccess';

const InkindPage = () => {
  const { t: tPageTitles } = useTranslation('pageTitles');

  const { checkAccess, isLoading: isLoadingAuth } = useAuth();
  const { read, write } = checkAccess('Inkind');

  const { isLoading: isLoadingTimeEntries } = useTimeEntries();

  if (isLoadingAuth || isLoadingTimeEntries) {
    return <LoadingPage text={tPageTitles('selfEffort')} />;
  }

  if (!read) {
    return <NoAccess />;
  }

  return (
    <ContentPage title={tPageTitles('selfEffort')} width="wide" hideBreadcrumbs>
      <InkindTable writeAccess={write} />
    </ContentPage>
  );
};

export default InkindPage;
